<template>
  <div>
    <Nav title="本期我的幸运码" />
    <div v-if="isLoading"></div>
    <div v-else>
      <div
        class="my_luck_not_data"
        v-if="luckyCodes == null || luckyCodes.length == 0"
      >
        <img class="img" src="../../assets/lottery/no_img.png" alt="无数据" />
        <div class="title">还没有幸运码～</div>
        <button class="button btn" @click="exchange">去兑换</button>
      </div>
      <div
        class="my_luck_data"
        v-if="luckyCodes != null && luckyCodes.length > 0"
      >
        <div
          class="myluck_exchang"
          v-for="(value, index) in luckyCodes"
          :key="index"
        >
          <div class="myluck_exchang_bg">
            <div class="myluck_exchang_index">{{ value.num }}</div>
            <div class="myluck_exchang_code">{{ value.code }}</div>
            <div class="myluck_exchang_num">{{ value.createdAt }}</div>
            <div class="myluck_exchang_no_draw" v-if="value.status == 0">
              未开奖
            </div>
            <div class="myluck_exchang_no_winning" v-if="value.status == -1">
              未中奖
            </div>
            <div class="myluck_exchang_winning" v-if="value.status == 1">
              <img
                class="myluck_exchang_winning_image"
                src="../../assets/lottery/winning_decoration_bg_s.png"
                alt="中奖了"
              />
              <div class="myluck_exchang_winning_title">中奖了</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { MyLuckyCodes } from "../../model/lottery/LotteryModel";
import Nav from "../../components/nav/Nav.vue";

@Options({
  components: { Nav }
})
export default class MyLuck extends Vue {
  luckyCodes: MyLuckyCodes[] = [];
  isLoading = true;
  mounted() {
    this.initData();
  }
  initData() {
    this.isLoading = true;
    Http.post<MyLuckyCodes[]>(Urls.lottery_getMyLuckyCodes, null).then(
      (res: MyLuckyCodes[]) => {
        this.isLoading = false;
        this.luckyCodes = res;
      },
      (err: ResponseData) => {
        this.isLoading = false;
        console.log(Urls.lottery_getMyLuckyCodes, err.message);
        // openToast(err.message);
      }
    );
  }
  exchange() {
    this.$router.back();
  }
}
</script>
<style lang="less">
@import "../../style/BaseStyle.less";
.my_luck_not_data {
  background-color: #f5f5f5;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  top: 44px;
  .img {
    margin: 0 auto;
    margin-top: 110px;
    width: 130px;
  }
  .title {
    margin-top: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #484444;
  }
  .btn {
    margin-top: 48px;
    color: #ffffff;
    background-color: #f64746;
    border-radius: 30px;
    padding: 10px 77px;
    font-size: 15px;
  }
}
.my_luck_data {
  background-color: #f6f6f6;
  width: 100%;
  position: fixed;
  margin: 0 auto;
  left: 0px;
  bottom: 0;
  top: 44px;
  overflow-y: scroll;
  padding-top: 20px;
  .myluck_exchang {
    display: inline;
    border-radius: 10px;
    overflow: hidden;
    margin: 0 auto;
    .myluck_exchang_bg {
      background-color: rgb(241, 233, 233);
      width: ~"calc((100% - 60px) / 2)";
      height: 160px;
      background-color: white;
      border-radius: 10px;
      overflow: hidden;
      float: left;
      margin: 0px 0px 20px 20px;
    }
    .myluck_exchang_index {
      background-color: #f7f7f7;
      font-size: 12px;
      color: #111111;
      width: 46px;
      border-radius: 0 0 100px 100px;
      text-align: center;
      margin: 0 auto;
    }
    .myluck_exchang_code {
      margin: 26px 0px 0px 0px;
      font-size: 24px;
      font-weight: bold;
      color: #ff1e1e;
    }
    .myluck_exchang_num {
      margin: 4px 0px 0px 0px;
      font-size: 12px;
      color: #111111;
    }
    /// 未开奖
    .myluck_exchang_no_draw {
      margin: 22px 0px 0px 0px;
      font-size: 15px;
      color: #d3d3d3;
    }
    /// 未中奖
    .myluck_exchang_no_winning {
      text-align: center;
      margin: 0 auto;
      margin-top: 22px;
      font-size: 15px;
      width: 72px;
      color: #d3d3d3;
      border: 1px dotted #aaaaaa;
      border-radius: 6px;
    }
    /// 中奖
    .myluck_exchang_winning {
      // position: fixed;
      text-align: center;
      align-items: center;
      justify-content: center;
      align-content: center;
      margin: auto 0;
      margin-top: 14px;
      position: relative;
      .myluck_exchang_winning_image {
        position: absolute;
        left: 0;
        right: 0;
        justify-content: center;
        align-content: center;
        margin: 0 auto;
      }
      .myluck_exchang_winning_title {
        position: absolute;
        left: 0;
        right: 0;
        justify-content: center;
        margin: 0px auto;
        margin-top: 5px;
        font-weight: bold;
        color: #ffffff;
        font-size: 15px;
        text-align: center;
      }
    }
  }
}
</style>
